import { Model } from "../model";

import { HasSocketEvent } from "@models";
import { SocketEvent } from "@helpers/types";
import { CURRENCY_TYPE } from "@helpers/constants";
import { DarkModeService } from "@core-services/dark-mode.service";
import { ServiceLocator } from "@helpers/service-locator";

export abstract class Currency extends Model implements HasSocketEvent {
	protected static readonly currencyType: string = CURRENCY_TYPE;

	protected name: string = "";
	protected symbol: string = "";
	protected logo: string = "";
	protected logo_dark: string = "";
	protected is_token: boolean = false;
	protected pid: string = "";

	protected darkModeService?: DarkModeService;

	public abstract getPrecision(): number;
	public abstract getPrecisionFiat(): number;
	public abstract getIconCssName(lc: boolean): string;

	public constructor() {
		super();
		this.darkModeService = ServiceLocator.injector?.get(DarkModeService);
	}

	public eventData: SocketEvent = "";

	public getEvent(): string {
		return this.eventData;
	}

	public getName(): string {
		return this.name;
	}

	public getCurrencyType(): string {
		return Currency.currencyType;
	}

	public getSymbol(lowerCase: boolean = false, name: boolean = false): string {
		return lowerCase ? this.symbol.toLocaleLowerCase() : this.symbol;
	}

	public getPid(): string {
		return this.pid;
	}

	public getLogo(): string {
		const logo = this.darkModeService?.darkModeEnabled ? this.getLogoDark() : this.getLogoLight();

		if (!logo) {
			return this.getDefaultLogo();
		}

		return logo;
	}

	public getLogoLight(): string {
		return this.logo;
	}

	public getLogoDark(): string {
		return this.logo_dark;
	}

	public getDefaultLogo(): string {
		return "/assets/images/default-asset.svg";
	}

	public isToken(): boolean {
		return this.is_token;
	}
}
